import React from 'react';
import { Field } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';
import * as validator from 'helpers/Validator';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import MenuItem from '@material-ui/core/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import { RenderGhostError } from 'components/shared/RenderError';
import { getTranslatedString } from 'helpers/i18n';

export const renderpersonalReferences = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div className="row">
    <CSSTransitionGroup
      transitionName="application_add_landlord_reference"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {fields.map((personalReference, index) => (
        <div key={index} className="row">
          <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
            <h4 style={{ lineHeight: '26px' }}>
              {getTranslatedString('tenantPortal.application.personalReferenceArray', {
                index: index + 1,
              })}
              <IconButton
                style={{
                  padding: 0,
                  verticalAlign: 'text-bottom',
                  width: 'none',
                  height: 'none',
                  float: 'right',
                }}
                onClick={() => {
                  if (fields.getAll()[index].id) {
                    this.props.deletePersonalReference(fields.getAll()[index].id);
                  }
                  fields.remove(index);
                }}
              >
                <DeleteIcon size={24} style={{ padding: 0 }} />
              </IconButton>
            </h4>
          </div>

          <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${personalReference}.personalReferenceName`}
                type="text"
                component={TextField}
                variant="outlined"
                label={getTranslatedString('tenantPortal.application.personalReferenceArray.name')}
                style={{ fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field
                name={`${personalReference}.personalReferenceName`}
                component={RenderGhostError}
              />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${personalReference}.personalReferenceEmail`}
                type="text"
                component={TextField}
                label={getTranslatedString('tenantPortal.application.personalReferenceArray.email')}
                variant="outlined"
                style={{ fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field
                name={`${personalReference}.personalReferenceEmail`}
                component={RenderGhostError}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${personalReference}.personalReferencePhoneNumber`}
                type="text"
                component={ReactPhoneInput}
                validate={[validator.required, validator.validInternationalPhoneNumber]}
                label={getTranslatedString('tenantPortal.application.personalReferenceArray.phone')}
                style={{ fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field
                name={`${personalReference}.personalReferencePhoneNumber`}
                component={RenderGhostError}
              />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${personalReference}.relationshipType`}
                component={OutlinedSelect}
                label={getTranslatedString(
                  'tenantPortal.application.personalReferenceArray.relationship'
                )}
                style={{ fontSize: '14px', textAlign: 'left' }}
                errorStyle={{ fontSize: '14px' }}
              >
                <MenuItem key="rel_val_1" value="Co-Worker">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.co-worker'
                  )}
                </MenuItem>
                <MenuItem key="rel_val_2" value="Employee">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.employee'
                  )}
                </MenuItem>
                <MenuItem key="rel_val_3" value="Friend">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.friend'
                  )}
                </MenuItem>
                <MenuItem key="rel_val_4" value="Manager">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.manager'
                  )}
                </MenuItem>
              </Field>
              <Field name={`${personalReference}.relationshipType`} component={RenderGhostError} />
            </div>
          </div>
          <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-sm-3" />
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${personalReference}.relationshipDuration`}
                component={OutlinedSelect}
                label={getTranslatedString(
                  'tenantPortal.application.personalReferenceArray.relationship.length'
                )}
                style={{ fontSize: '14px', textAlign: 'left' }}
                errorStyle={{ fontSize: '14px' }}
              >
                <MenuItem key="val_1" value="<1 Year">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.<1y'
                  )}
                </MenuItem>
                <MenuItem key="val_2" value="1 Year">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.1y'
                  )}
                </MenuItem>
                <MenuItem key="val_3" value="2 Years">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.2y'
                  )}
                </MenuItem>
                <MenuItem key="val_4" value="3 Years">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.3y'
                  )}
                </MenuItem>
                <MenuItem key="val_5" value="4 Years">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.4y'
                  )}
                </MenuItem>
                <MenuItem key="val_6" value="5+ Years">
                  {getTranslatedString(
                    'tenantPortal.application.personalReferenceArray.relationship.length.5yPlus'
                  )}
                </MenuItem>
              </Field>
              <Field
                name={`${personalReference}.relationshipDuration`}
                component={RenderGhostError}
              />
            </div>
          </div>
        </div>
      ))}
    </CSSTransitionGroup>
    <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
      <FlatButton
        label={getTranslatedString('tenantPortal.application.personalReferenceArray.add')}
        type="button"
        backgroundColor={AccentColor()}
        hoverColor="grey"
        style={{ color: 'white' }}
        onClick={() => {
          fields.push({});
          setTimeout(
            () =>
              document.getElementById('button')
                ? document
                    .getElementById('button')
                    .scrollIntoView({ block: 'end', behaviour: 'smooth' })
                : null,
            0
          );
        }}
      />

      {error && (
        <p
          style={{
            marginTop: '10px',
            fontSize: '11px',
            color: AccentColor(),
          }}
          id="errorMessage"
        >
          {error}
        </p>
      )}
    </div>
  </div>
);
